import styled from 'styled-components';
import { Button } from 'reactstrap';
import { color } from '../../../assets/styles/colors';

export const ButtonAprovar = styled(Button)`
	background-color: ${color.yellow};
	border-radius: 50;
`;

export const TrStyled = styled.tr`
	background: ${color.primary};
	color: ${color.black} !important;

	th {
		text-align: center;
		//padding: 10px;

		&:not(:last-child) {
			border-right: 1px solid ${color.black} !important;
		}

		&::after {
			width: 0 !important;
		}
	}
`;

export const SolicitarButtonStyled = styled(Button)`
	padding: 0 15px;
	min-height: 35px;
	background-color: ${(props) => props.disabled ? color.grayMedium : color.white} !important;
	color: ${(props) => props.disabled ? color.gray : color.yellow} !important;
	border-color: ${(props) => props.disabled ? color.gray : color.yellow} !important;

	&:hover {
		color: ${color.yellow} !important;
		background-color: #fff9c5 !important;
	}
`;
